// The register lookups most screens need: tasks by code.
import { useMemo } from "react";
import type { TaskRow } from "./types";
import { useApi } from "../api/live";
import { paths } from "../api/paths";

export function useTasks() {
  const r = useApi<TaskRow[]>(paths.tasks(), ["task", "register", "setting"]);
  const byCode = useMemo(() => Object.fromEntries((r.data ?? []).map((t) => [t.code, t])) as Record<string, TaskRow>, [r.data]);
  return { ...r, tasks: r.data ?? [], byCode };
}
